<template>
  <div>
    <div class="container-fluid mobile-margin">
      <div class="row">
        <div class="card border-0" style="background:#ffffff00; border-radius: 15px;">
          <div class="card-body card-overdue" style="overflow-x: visible;">
            <div class="row" style="min-width:50px; top:0%;">
              <div class="col-12 text-start align-middle">
                <span style="font-size:16px; color:white;" class="text-stroke">Click Throughs on Phishing Test Emails</span>
              </div>
            </div>
            <div class="row">
              <div class="col text-center mx-auto" v-if="loading">
                <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
                <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
              </div>


              <div id="chart mx-auto" style="margin-top:20px; font-size:14px;" v-else>
                <div v-if="series[0].data.length == 0">
                  <p class="p-5 text-center text-wrap fs-5">No Data</p>
                </div>
                <div v-else>
                  <div class="row p-1">
                    <div class="col-12 d-flex align-items-center">
                      <span for="dateFrom" class="me-2 text-sm text-default">Range: </span>
                      <Datepicker id="dateFrom" :enable-time-picker="false"
                        v-model="date" range auto-apply @cleared="handleClear"
                        @update:model-value="handleDate" placeholder="Select date range" input-class-name="date-picker-input"
                        format="yyyy/MM/dd" :max-date="new Date()"/>
                    </div>
                  </div>
                  <div class="row mt-2 px-0">
                    <div class="col-12 d-flex justify-content-center align-items-center" v-if="!noData">
                      <apexchart type="line" height="350" :width="470" :options="chartOptions" :series="series" />
                    </div>
                    <div class="col-12 d-flex justify-content-center align-items-center text-default" v-else>
                      <p class="p-5 mb-0">No date range selected.</p>
                    </div>
                  </div>
                  <div class="d-flex p-1">
                    <button :disabled="downloading" type="button" class="btn btn-labeled default btn-sm" v-tooltip.top="'Download detailed Phishing Report'" :class="{ 'text-small': vssWidth <= 1065  }"   @mouseover="btnDownload = 'white'" @mouseleave="btnDownload= '#00A0C1'" @click="downloadPhishingSummary">
                      <div v-if="downloading" class="spinner-border" role="status" style="height:15px; width:15px;">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <span class="btn-label" v-if="!downloading">
                      <svg width="17" :height="vssWidth <= 1065 ? 14 : 16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.35682 11.3864C8.37383 11.4081 8.39556 11.4257 8.42036 11.4378C8.44517 11.4498 8.4724 11.4561 8.5 11.4561C8.5276 11.4561 8.55483 11.4498 8.57964 11.4378C8.60444 11.4257 8.62617 11.4081 8.64318 11.3864L11.1886 8.16591C11.2818 8.04773 11.1977 7.87273 11.0455 7.87273H9.36136V0.181818C9.36136 0.0818182 9.27955 0 9.17955 0H7.81591C7.71591 0 7.63409 0.0818182 7.63409 0.181818V7.87045H5.95455C5.80227 7.87045 5.71818 8.04546 5.81136 8.16364L8.35682 11.3864ZM16.8182 10.5909H15.4545C15.3545 10.5909 15.2727 10.6727 15.2727 10.7727V14.2727H1.72727V10.7727C1.72727 10.6727 1.64545 10.5909 1.54545 10.5909H0.181818C0.0818182 10.5909 0 10.6727 0 10.7727V15.2727C0 15.675 0.325 16 0.727273 16H16.2727C16.675 16 17 15.675 17 15.2727V10.7727C17 10.6727 16.9182 10.5909 16.8182 10.5909Z" :fill="btnDownload"/>
                      </svg></span> <span class="d-none d-sm-inline">Download Report (.xlsx)</span>
                    </button>
                  </div>

                </div>
              </div>
            </div>




          </div>
        </div>
      </div>
       </div>
   </div>
 </template>

 <script>
  import moment from 'moment';
  import * as XLSX from 'xlsx'

  export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],

     data() {
        return {
          loading: true,
          downloading: false,
          btnDownload: "#00A0C1",
          series: [{
              name: "Click Throughs",
              data: [],
          },
          {
              name: "Emails Sent",
              data: [],
          }
        ],
          chartOptions: {
            chart: {
              fontFamily: 'Roboto, sans-serif',
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: true,
                tools:{
                  download:false
                }
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth'
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              labels: {
                formatter: (value) => {
                  return value.toFixed(1)
                },
              }
            },
          },
          range:{
            from:moment().subtract(14, 'days').format('YYYY-MM-DD'),
            to:moment().format('YYYY-MM-DD'),
          },
          date: null,
          clear: false,
          noData: false,
      }
    },

    async created() {
      if (!this.showProduct) return

      this.vssWidth = this.$vssWidth;
      this.date = [this.range.from, this.range.to];
      await this.init()
    },

    methods: {
      async init(){
        this.overdueTrainings = [];
        this.quizResults = [];
        this.loading = true;

        this.getData()
      },

      formatDateLabel(date) {
        return moment(date).format('DD MMM');
      },

      formatInputLabel(date) {
        if (date == null) return;

        return date.map(d => moment(d).format('YYYY/MM/DD')).join(' - ');
      },

      getData() {
        let params = {
          from: this.range.from,
          to: this.range.to,
        };

        if (this.isManager)  params.manager = this.isManager;

        return new Promise((resolve, reject) => {
          this.$axios.get("/orgadmin/organisations/" + this.organisationID + "/phishing/click-through", { params })
            .then(response => {
              if (response.data.success) {

                // map click through data
                let clickCount = response.data.click_count;
                let labels = Object.keys(clickCount).map(date => {
                  return { originalDate: date, formattedDate: this.formatDateLabel(date) };
                });
                let seriesData = Object.values(clickCount);
                this.series[0].data = seriesData;

                // map email sent
                let emailSent = response.data.email_sent;
                let emailSentData = Object.values(emailSent);
                this.series[1].data = emailSentData;

                this.chartOptions.xaxis.categories = labels.map(item => item.formattedDate);

                this.loading = false;
                resolve();
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },

      handleDate(){
        if (this.date == null) return;

        if (this.date[1] == null){
          this.$toast.error("Please select a valid date range");
          return;
        }

        //set date ranges
        this.range.from = moment(this.date[0]).format('YYYY-MM-DD');
        this.range.to = moment(this.date[1]).format('YYYY-MM-DD');

        // set loading state
        this.loading = true;
        //get new data
        this.getData();
      },

      async downloadReport() {
      if (!this.$store.state.user.organisation) {return;}

      let params = {
          from: this.range.from,
          to: this.range.to,
        };

      if (this.isManager)  params.manager = this.isManager;

      let data = await this.$axios.get("/orgadmin/organisations/" + this.organisationID + "/phishing/click-through/download", { params })
          .then((response) => {
              return response.data.phishing_report
          })
          .catch();

      return data;

    },

      async downloadPhishingSummary() {
        this.downloading = true;

        let data = await this.preparePhishingSummary();
        var dateToday = moment().format("YYYYMMDD");


        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "PhishingSummary");
        /* generate file and send to client */

        XLSX.writeFile(wb, dateToday + "_" + this.formattedOrgName + "_Phishing Report.xlsx");

        this.downloading = false;
        this.btnDownload = '#00A0C1';
      },

      async preparePhishingSummary() {
        let phishingSummaries = await this.downloadReport();
        let rows = [["User", "Email", "Template", "Date Email Sent (UTC)", "Date First Click (UTC)", "Total Clicks", "Action Taken"]];

        for (const phishingSummary of phishingSummaries) {
          // fix for click links where default is zero
          // considered as 1 click since they have a record on click-logs
          if (phishingSummary["total_clicks"] == 0 && phishingSummary["action_taken" != "No Action"])
            phishingSummary["total_clicks"]++

            rows.push([
              phishingSummary["user_name"],
              phishingSummary["email"],
              phishingSummary["template"],
              phishingSummary["date_email_sent"] && phishingSummary["date_email_sent"] !== "0001-01-01T00:00:00Z" ? moment.utc(phishingSummary["date_email_sent"]).format("DD/MM/yyyy") : null,
              phishingSummary["action_taken"] === "No Action" ? null : (phishingSummary["date_first_clicked"] && phishingSummary["date_first_clicked"] !== "0001-01-01T00:00:00Z" ? moment.utc(phishingSummary["date_first_clicked"]).format("DD/MM/yyyy h:mm a") : null),
              phishingSummary["total_clicks"],
              phishingSummary["action_taken"],
            ]);
        }
        return rows;
      },

      handleClear() {
        this.range = { ...this.defaultRange };
        // this.loading = true;
        // this.getData();
      }
  },

  computed: {
    orgName(){
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation
    },

    formattedOrgName() {
      if (this.orgName) {
        if (this.orgName.includes(" ")) {
          // If orgName contains spaces, replace them with underscores
          return this.orgName.replace(/ /g, "_");
        } else {
          // If orgName doesn't contain spaces, keep it as is
          return this.orgName;
        }
      }
      return "";
    },

    defaultRange() {
      return {
        from: null,
        to: null,
      };
    },

  },

  watch: {
    range: {
      handler(newValue) {
        // Check if the range is null or has null values
        if (newValue.from === null || newValue.to === null) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      deep: true, // Deep watch to react to changes within the range object
    },
  },

  }

 </script>
 <style scoped>
 .card-overdue {
   border-radius: 15px;
   background: #ffffff;
   overflow: auto;

   background: #00a0c1; /* Old browsers */
     background: -moz-linear-gradient(top,  #00a0c1 0%, #00a0c1 50px, #ffffff 50px); /* FF3.6-15 */
     background: -webkit-linear-gradient(top,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* Chrome10-25,Safari5.1-6 */
     background: linear-gradient(to bottom,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
 }

 .pagination > li > a
  {
    background-color: white;
    color: #00a0c1;
  }

 .pagination > li > span
  {
    background-color: white;
    color: #00a0c1;
  }
 .pagination > li > span:hover
  {
    background-color: white;
    color: #00a0c1;
  }

  .text-stroke{
    text-shadow: 0 0 2px #00a0c1; /* horizontal-offset vertical-offset 'blur' colour */
    -moz-text-shadow: 0 0 2px #1c5f6d;
    -webkit-text-shadow: 0 0 2px #00a0c1;
  }

  .expand tr td {
    border-top: none !important;
    border-bottom: none !important;
    font-size:14px;
  }

 </style>